/**
 * "More {Event} Tickets" data — other upcoming dates of the same show.
 *
 * Shared by ListingPage.duck.js (SSR: fetched in loadData so the section is in the
 * first HTML — no post-paint insert / CLS) and SectionRelatedShowListings (client
 * fallback when the SSR fetch failed).
 */

import { sameOriginApiBase } from './sameOriginApiBase';
import { resolveEventEntityName } from './listingSeoCopy';

/**
 * Query params for /api/seo-discovery/related-listings, or null when the listing
 * has no resolvable event name (non-event listings).
 */
export const relatedShowListingsParams = ({ listingId, title, publicData }) => {
  const eventLabel = resolveEventEntityName({ title, publicData });
  if (!eventLabel || eventLabel === 'Event') {
    return null;
  }
  const pd = publicData || {};
  return {
    eventName: eventLabel,
    ...(listingId ? { excludeListingId: String(listingId) } : {}),
    ...(pd.ticketNetworkEventId ? { excludeEventId: String(pd.ticketNetworkEventId) } : {}),
    ...(pd.ticketNetworkVenueId ? { venueId: String(pd.ticketNetworkVenueId) } : {}),
    limit: '12',
  };
};

/**
 * Fetch related show listings. Works in the browser (page origin) and during SSR
 * (loopback on PORT via sameOriginApiBase). Resolves to the payload or null.
 */
export const fetchRelatedShowListings = params => {
  const base = sameOriginApiBase();
  if (!base || !params || typeof fetch !== 'function') {
    return Promise.resolve(null);
  }
  const query = new URLSearchParams(params).toString();
  return fetch(`${base}/api/seo-discovery/related-listings?${query}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(res => (res.ok ? res.json() : null))
    .catch(() => null);
};
